import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/Logo.png" alt="Wadi empire and builds Ltd" className="logo-img" />
              <span>Wadi empire and builds Ltd</span>
            </div>
            <p>Engaging in real estate purchase and sales, land and estate development, and agricultural development and production. Building a better future for our communities.</p>
            <div className="social-links">
              <a href="#" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
              <a href="#" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
              <a href="#" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
              <a href="#" aria-label="WhatsApp"><i className="fab fa-whatsapp"></i></a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Our Services</h4>
            <ul>
              <li><a href="#services">Real Estate Purchase & Sales</a></li>
              <li><a href="#services">Land & Estate Development</a></li>
              <li><a href="#services">Agricultural Development & Production</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <span>KRIZTAL COURT ESTATE, NEAR GOSHEN ESTATE, PYAKASSA, LUGBE, AMAC, FCT.</span>
            </div>
            <div className="contact-item">
              <i className="fas fa-phone"></i>
              <span>+234 9164315643</span>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 Jarvis Surgical. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;